import * as cx from 'classnames';
import {
    BACK_TO_TOPICS,
    SERVER_FULL_NAME,
    WIKI_DO_YOU_HAVE_EXPERIENCE_WITH_title,
    WIKI_EXP_AVERAGE_SCORE,
    WIKI_EXPERIENCES_WITH_title,
    WIKI_SHARE_YOUR_EXPERIENCE_AND_HELP_OTHERS,
    WIKI_WRITE_YOUR_EXPERIENCE,
} from 'mk/autogenerated/translations/Article.df49464b4006f5403ae569ffd458ee3c'
import { isAuthenticated } from 'mk/bazaar/common/userUtils';
import * as forumUrls from 'mk2/apps/forum/urls';
import * as homeUrls from 'mk2/apps/home/urls';
import ArticleBody from 'mk2/apps/wiki/components/ArticleBody';
import Experience from 'mk2/apps/wiki/components/Experience';
import FeedbackForm from 'mk2/apps/wiki/components/FeedbackForm';
import { Props } from 'mk2/apps/wiki/containers/Article/ArticlePage';
import * as wikiUrls from 'mk2/apps/wiki/urls';
import { isCategoryArticle, wikiArticleUrl, wikiCategoryUrl } from 'mk2/apps/wiki/utils';
import { BreadcrumbSiteStructure } from 'mk2/components/BreadcrumbSiteStructure';
import Btn, { BtnType } from 'mk2/components/Btn';
import Failure from 'mk2/components/errors/Failure';
import Link from 'mk2/components/Link';
import StarsRating from 'mk2/components/StarsRating';
import LoadingSwitch from 'mk2/containers/LoadingSwitch/LoadingSwitch';
// import NewsletterModal from 'mk2/containers/NewsletterModal/NewsletterModal';
// import {
//     wikiArticlesWithNewsletterModal,
//     wikiTopicsWithNewsletter,
// } from 'mk2/containers/NewsletterModal/NewsletterModal.constants';
import { scrollElementTo } from 'mk2/helpers/scrolling';
import { url } from 'mk2/helpers/urls';
import { isSuccess, LoadingState } from 'mk2/reducers/loadingState';
import { interpolate } from 'mk2/services/i18n';
import * as React from 'react';
import Helmet from 'react-helmet';
import styles from './Article.mscss';

class Article extends React.Component<Props> {

    public static getAverageRating(experiences) {
        let sum = 0;
        let ratedExp = 0;
        for (let i = 0; experiences.length > i; i++) {
            if (experiences[i].starsCount) {
                ratedExp += 1;
                sum += experiences[i].starsCount;
            }
        }
        return Math.round(sum / ratedExp);
    }

    public componentDidMount() {
        const { experienceIdRef, loadingState } = this.props;
        // Scroll only if content is loaded
        if (experienceIdRef && isSuccess(loadingState)) {
            scrollElementTo(experienceIdRef, 'window-top');
        }
    }

    public componentDidUpdate(prevProps: Props) {
        const { experienceIdRef, loadingState } = this.props;
        if (experienceIdRef && prevProps.loadingState === LoadingState.LOADING && loadingState === LoadingState.SUCCESS) { // Content is now loaded
            scrollElementTo(experienceIdRef, 'window-top');
        }
    }

    public render() {
        const { loadingState, article } = this.props;
        return (
            <div>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderSuccess={this.renderLoadSuccess}
                    onRenderFailure={this.renderFailure}
                    hasData={!!article}
                />
            </div>
        );
    }

    private load = () => {
        const { match: { params: { articleSlug, categorySlug } }, onLoad} = this.props;
        onLoad(articleSlug, categorySlug);
    };

    private renderLoadSuccess = () => {
        const {
            article, requestUser, requestUserPermissions, mobile, onToggleMenuMore, onSaveFeedBack, onAddExperience,
            feedbackSubmitted, baseUrl,
        } = this.props;

        const isAdmin = requestUserPermissions.indexOf('wiki.can_edit_wiki') >= 0;

        return (
            <div>
                <div className={styles.Article}>
                    <Helmet>
                        <link rel="canonical" href={baseUrl + wikiArticleUrl(article)}/>
                    </Helmet>

                    <BreadcrumbSiteStructure
                        className={styles.Article__breadcrumb}
                        items={[
                            <Link key="main" to={homeUrls.homepage}>{SERVER_FULL_NAME}</Link>,
                            <Link
                                className={cx(isCategoryArticle(article) && styles.Article__breadcrumbItemDisabled)}
                                key={article.category.id}
                                to={wikiCategoryUrl(article.category)}
                            >
                                {article.category.name}
                            </Link>,
                        ]}
                    />

                    <ArticleBody
                        article={article}
                        followLinks
                    />
                    <FeedbackForm
                        article={article}
                        requestUser={requestUser}
                        isMobile={mobile}
                        onSave={onSaveFeedBack}
                        hideForm={feedbackSubmitted}
                    />
                </div>

                {article.experiencesAllowed && (
                    <div id={'experiences'} className={styles.ArticleExperiences}>
                        <h2 className={styles.ArticleExperiences__sectionHeader}>
                            <i className={cx('fa', 'fa-comment-o', styles.ArticleExperiences__sectionHeader__icon)} />{' '}
                            {interpolate(WIKI_EXPERIENCES_WITH_title, {title: article.instrumentalTitle})}
                        </h2>

                        {article.experiencesStarsAllowed &&
                            <StarsRating
                                starsCount={Article.getAverageRating(article.experiences)}
                                label={WIKI_EXP_AVERAGE_SCORE}
                                className={styles.ArticleExperiences__starsRating}
                            />
                        }

                        <div className={styles.ArticleExperiences__addExperience}>
                            <div className={styles.ArticleExperiences__addExperience__header}>{interpolate(WIKI_DO_YOU_HAVE_EXPERIENCE_WITH_title, {title: article.instrumentalTitle})}</div>
                            <div className={styles.ArticleExperiences__addExperience__message}>{WIKI_SHARE_YOUR_EXPERIENCE_AND_HELP_OTHERS}</div>
                            <Btn
                                className={styles.ArticleExperiences__addExperience__button}
                                type={BtnType.Blue}
                                icon="fa-comment-o"
                                label={WIKI_WRITE_YOUR_EXPERIENCE}
                                onClick={isAuthenticated(requestUser) ? null : onAddExperience}
                                link={isAuthenticated(requestUser) ? url(wikiUrls.wikiAddExperience, { articleSlug: article.slug, categorySlug: article.category.slug }) : null}
                            />
                        </div>

                        {article.experiences.map((experience, id) => {
                            return (
                                <Experience
                                    key={id}
                                    experience={experience}
                                    isMobile={mobile}
                                    hasMenu={isAdmin}
                                    onToggleMenuMore={onToggleMenuMore}
                                    article={article}
                                />
                            );
                        })}
                    </div>
                )}
                {/*isAnonymous(requestUser) && ((wikiTopicsWithNewsletter.indexOf(article.category.slug) >= 0 || wikiArticlesWithNewsletterModal.indexOf(article.slug) >= 0)) && (
                    <NewsletterModal />
                )*/}
            </div>
        );
    };

    private renderFailure = () => {
        const { staticContext, errorMessage } = this.props;

        return (
            <Failure
                staticContext={staticContext}
                errorMessage={errorMessage}
                onRetry={this.load}
                backButton={
                    <Btn
                        type={BtnType.Blue}
                        label={BACK_TO_TOPICS}
                        icon="fa-arrow-left"
                        link={forumUrls.forumTopics}
                    />
                }
            />
        );
    };

}

export default Article;
